module.exports = require("@javascript-obfuscator/escodegen");